import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-full-persona',
  standalone: false,
  templateUrl: './full-persona.component.html',
  styleUrl: './full-persona.component.scss'
})
export class FullPersonaComponent {

  readonly persona = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<FullPersonaComponent>);

  html: string = "No Data"
  image: string = ""
  constructor() {
    console.log(this.persona);

    this.generateHtmlFromObject(this.persona.persona, 0).then((html) => {
      this.html = html;
    });

  }
  /*async generateHtmlFromObject(obj: any, counter: number): Promise<string> {
    return new Promise(async (resolve) => {
      let c = "";
      for (const key in obj) {
        if (key === 'image') {
          this.image = obj[key];
          continue;
        }
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object') {
            counter++;
            let r = await this.generateHtmlFromObject(obj[key], counter);
            let z = parseInt(key);
            if (isNaN(z)) {
              let n = key.replace(/_/g, ' ');
              n = n.charAt(0).toUpperCase() + n.slice(1);
              c += `<div class="subsection counter-${counter}"><h3>${n}</h3><p>${r}</p></div>`;
            } else {
              c += `<div class="subsection counter-${counter}""><p>${r}</p></div>`;
            }

          } else if (Array.isArray(obj[key])) {
            let r = await obj[key].map((item: any) => `<li>${item}</li>`).join('');
            c += `<div class="subsection"><ul>${r}</ul></div>`;

          } else {
            let z = parseInt(key);
            if (isNaN(z)) {
              let n = key.replace(/_/g, ' ');
              n = n.charAt(0).toUpperCase() + n.slice(1);
              c += `<div class="subsection"><h3>${n}</h3>${obj[key]}</div>`;
            } else {
              c += `<div class="subsection">${obj[key]}</div>`;
            }
          }
        }
      }

      resolve(c);


    });
  }*/

  async generateHtmlFromObject(obj: any, counter: number = 1): Promise<string> {
    return new Promise(async (resolve) => {
      let html = "";
  
      for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;
        if (key === "image") {
          this.image = obj[key];
          continue;
        }
  
        const value = obj[key];
        const numericKey = !isNaN(parseInt(key));
        const displayKey = numericKey
          ? ""
          : key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  
        // Object (subsection)
        if (typeof value === "object" && !Array.isArray(value)) {
          const nestedHtml = await this.generateHtmlFromObject(value, counter + 1);
          html += `
            <section class="section level-${counter}">
              ${!numericKey ? `<h2 class="section-title">${displayKey}</h2>` : ""}
              <div class="section-content">${nestedHtml}</div>
            </section>
          `;
        }
  
        // Array
        else if (Array.isArray(value)) {
          const listItems = value.map((item: any) => `<li>${item}</li>`).join("");
          html += `
            <section class="section level-${counter}">
              ${!numericKey ? `<h3>${displayKey}</h3>` : ""}
              <ul class="section-list">${listItems}</ul>
            </section>
          `;
        }
  
        // Primitive key–value
        else {
          html += `
            <div class="info-row level-${counter}">
              ${!numericKey ? `<h3 class="key-heading">${displayKey}</h3>` : ""}
              <span class="info-value">${value}</span>
            </div>
          `;
        }
      }
  
      resolve(html);
    });
  }

  closePersona() {
    this.html = "No Data";
    this.dialogRef.close();
  }
}
